import type { FC } from 'react';
import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';

/**
 * Renders the loading bars used in the property slot of a full card skeleton.
 * @returns Aligned photo, title, price, and inline-code placeholders.
 */
export const ConversationPropertySummarySkeleton: FC = () => (
  <div
    className="flex min-h-[52px] min-w-0 items-start gap-[7px] border-t border-solid pt-[7px] border-neutral-100"
    aria-hidden="true"
  >
    <div className="h-[34px] w-[29px] flex-none overflow-hidden rounded-[7px]">
      <div className="h-full w-full flex-none object-cover animate-pulse bg-neutral-100" />
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-px">
      <div className="flex h-3.5 items-center">
        <TextSkeleton className="!h-[9px] w-full" />
      </div>
      <div className="flex h-3.5 items-center">
        <TextSkeleton className="!h-[9px] w-2/3" />
      </div>
      <div className="flex h-3.5 items-center">
        <TextSkeleton className="!h-[9px] w-[30px]" />
      </div>
    </div>
  </div>
);
